















import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class Badge extends Vue {
    @Prop({type: String, default: 'default'}) readonly type!: string
    @Prop({type: String, default: 'gold'}) readonly color!: string
    @Prop({type: Boolean, default: false}) readonly showLabel!: boolean
    @Prop({type: Boolean, default: false}) readonly showText!: boolean
    @Prop({type: Boolean, default: false}) readonly showDescription!: boolean
    @Prop({type: Number, default: 100}) readonly size!: boolean

    get badgeName(): string {
        return this.type + '-' + this.color
    }

    get badgeLabel(): string {
        return this.$t('gamification.types.' + this.type).toString()
    }

    get badgeDescription(): string {
        return this.$t('gamification.descriptions.' + this.type).toString()
    }

    get badgeSrc(): string {
        return require('@/assets/img/badge/badge-' + this.badgeName + '.png')
    }
}
